var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 2.8898C14.5684 3.50343 15.417 4.77762 15.417 6.25C15.417 7.72238 14.5684 8.99657 13.3337 9.6102M15.0003 13.972C16.2599 14.5419 17.3941 15.4708 18.3337 16.6667M1.66699 16.6667C3.28907 14.6021 5.49131 13.3333 7.91699 13.3333C10.3427 13.3333 12.5449 14.6021 14.167 16.6667M11.667 6.25C11.667 8.32107 9.98806 10 7.91699 10C5.84592 10 4.16699 8.32107 4.16699 6.25C4.16699 4.17893 5.84592 2.5 7.91699 2.5C9.98806 2.5 11.667 4.17893 11.667 6.25Z",
    stroke: "#004C3B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleRed);
export default __webpack_public_path__ + "static/media/PeopleRed.8ed4b989bd0a1fe7546990186db3d057.svg";
export { ForwardRef as ReactComponent };